// src/utils/taxRates.js

/**
 * Approximate combined sales tax rates (state + local) by state.
 * Data is only illustrative and may not reflect exact local rates.
 * For production use, consider a real-time tax service (e.g., TaxJar, Avalara).
 */
export const STATE_TAX_RATES = {
    AL: 0.0914, // Alabama
    AK: 0.0176, // Alaska
    AZ: 0.0840, // Arizona
    AR: 0.0947, // Arkansas
    CA: 0.0868, // California
    CO: 0.0777, // Colorado
    CT: 0.0635, // Connecticut
    DE: 0.0000, // Delaware
    FL: 0.0701, // Florida
    GA: 0.0735, // Georgia
    HI: 0.0444, // Hawaii (General Excise Tax)
    ID: 0.0602, // Idaho
    IL: 0.0873, // Illinois
    IN: 0.0700, // Indiana
    IA: 0.0694, // Iowa
    KS: 0.0868, // Kansas
    KY: 0.0600, // Kentucky
    LA: 0.0954, // Louisiana
    ME: 0.0550, // Maine
    MD: 0.0600, // Maryland
    MA: 0.0625, // Massachusetts
    MI: 0.0600, // Michigan
    MN: 0.0749, // Minnesota
    MS: 0.0707, // Mississippi
    MO: 0.0813, // Missouri
    MT: 0.0000, // Montana
    NE: 0.0694, // Nebraska
    NV: 0.0823, // Nevada
    NH: 0.0000, // New Hampshire
    NJ: 0.0660, // New Jersey
    NM: 0.0783, // New Mexico
    NY: 0.0875, // New York
    NC: 0.0698, // North Carolina
    ND: 0.0696, // North Dakota
    OH: 0.0730, // Ohio
    OK: 0.0898, // Oklahoma
    OR: 0.0000, // Oregon
    PA: 0.0634, // Pennsylvania
    RI: 0.0700, // Rhode Island
    SC: 0.0784, // South Carolina
    SD: 0.0650, // South Dakota
    TN: 0.0947, // Tennessee
    TX: 0.0820, // Texas
    UT: 0.0720, // Utah
    VT: 0.0624, // Vermont
    VA: 0.0575, // Virginia
    WA: 0.0929, // Washington
    WV: 0.0676, // West Virginia
    WI: 0.0543, // Wisconsin
    WY: 0.0536, // Wyoming
    DC: 0.0610, // District of Columbia
  };
  
  // Fallback rate if no match is found
  export const DEFAULT_TAX_RATE = 0.06;
  
  /**
   * Helper function to get the approximate tax rate for a given state code (e.g. "CA").
   * If stateAbbreviation not in table, returns DEFAULT_TAX_RATE.
   */
  export function getStateTaxRate(stateAbbreviation) {
    const upper = (stateAbbreviation || "").toUpperCase();
    return STATE_TAX_RATES[upper] ?? DEFAULT_TAX_RATE;
  }
  